/* Calzado Audor · ficha de producto — la barra fija de compra
   Nace de una medicion, no de un gusto: el 2026-09-24, en el navegador interno de
   Instagram —por donde entra el 98,4 % de la pauta— el «agregar al carrito» de la
   ficha queda a 703 px con el corte de pantalla en 689. Se pierde POR 14 PIXELES.
   Esta barra es la respuesta a esa fuga. El sticky nativo de Horizon nunca se activa
   (`data-stuck` siempre false, SOP §9.5), asi que se construye propio.

   DONDE SE PARA LA DECIDE EL CSS, NO ESTE ARCHIVO. La seccion es `position: sticky` al
   final de `main`, asi que el navegador la suelta sola en el borde del pie (SOP §9.25).
   Aqui solo se decide si se ENSENA o no. Mover la barra con JavaScript en cada fotograma
   de scroll la hacia temblar en celular: no se vuelve a hacer.

   LA FRANJA DE ARRIBA DICE UNA SOLA COSA A LA VEZ, y en este orden:
     1. escasez de LA TALLA ELEGIDA, en miel — «en su talla queda 1 par»
     2. el ahorro del escalon elegido, en verde — llega por el evento `aud:escalon`
     3. el mensaje de reposo, en verde — hoy, el envio gratis
   La escasez es SIEMPRE por talla, nunca por producto: la Ref 170 tiene 131 pares y
   un aviso sobre el producto seria mentira; sobre la talla 36, que tiene 2, es verdad.

   AQUI NO SE CALCULA NADA. Igual que en `aud-ficha.js` y `aud-escalones.js`: los
   importes llegan ya escritos en pesos desde Liquid. Se sustituye texto, no se
   multiplica. Un cambio de formato de moneda en la tienda no rompe esto.

   NO SE GUARDA NINGUNA REFERENCIA AL DOM DE LA SECCION PRINCIPAL. Horizon repinta
   `main` entero al cambiar de talla, asi que cualquier nodo guardado de ahi queda
   huerfano al primer clic. Todo lo de fuera se busca en el momento de usarlo.

   EL BOTON NO ENVIA EL FORMULARIO: hace clic en el boton real. Asi el carrito, el
   cajon, los errores y la analitica son los de Horizon, sin una segunda version que
   mantener. Si no hay boton real, la barra no aparece. */

const EVENTO = 'aud:escalon';

function componer(plantilla, piezas) {
  if (!plantilla) return '';
  let texto = plantilla;
  for (const [clave, valor] of Object.entries(piezas)) {
    texto = texto.split('{' + clave + '}').join(valor);
  }
  return texto;
}

function leerJson(texto) {
  try {
    return JSON.parse(texto || '{}');
  } catch {
    return {};
  }
}

class AudBarra extends HTMLElement {
  connectedCallback() {
    this.precios = leerJson(this.dataset.precios);
    this.escasez = leerJson(this.dataset.escasez);
    this.medidas = leerJson(this.dataset.medidas);

    this.opcion = this.dataset.opcion || 'Talla';
    this.plantillaTalla = this.dataset.plantillaTalla || '';
    this.plantillaSinCm = this.dataset.plantillaSinCm || '';
    this.mensajeReposo = this.dataset.mensaje || '';
    this.topeSuelto = parseInt(this.dataset.tope, 10) || 10;

    /* Referencias DENTRO de la barra: estas si son estables, la barra no se repinta. */
    this.refFranja = this.querySelector('[data-aud-franja]');
    this.refTalla = this.querySelector('[data-aud-talla]');
    this.refPrecio = this.querySelector('[data-aud-precio]');
    this.refValor = this.querySelector('[data-aud-valor]');
    this.refMas = this.querySelector('[data-aud-mas]');
    this.refMenos = this.querySelector('[data-aud-menos]');

    /* Lo que el escalon elegido haya dicho, para no perderlo al repintar la talla. */
    this.ahorroVigente = '';
    this.anzuelo = false;

    /* La talla abre el medidor compartido, que vive en `sections/aud-tallas.liquid` y
       escucha por delegacion en `document`. Liquid no puede saber si esa seccion esta en
       la plantilla, asi que se comprueba aqui por el id del dialogo: si no hay destino,
       la talla deja de ser boton y vuelve a ser texto. Se falla hacia ENSENARLO y se
       corrige, no al contrario: al contrario fue lo que dejo la guia de tallas encendida
       en 1 de 56 fichas (P-1). */
    this.refMedir = this.querySelector('[data-aud-medir]');
    if (this.refMedir && !document.getElementById('aud-pop')) {
      this.refMedir.classList.add('is-mudo');
      this.refMedir.removeAttribute('data-aud-medidor');
      this.refMedir.removeAttribute('aria-label');
      this.refMedir.disabled = true;
    }

    this.addEventListener('click', this.alClic);
    document.addEventListener('change', this.alCambiar);
    document.addEventListener(EVENTO, this.alEscalon);

    /* Capturando en `document`: desde 990 px lo que se desplaza es `.page-wrapper`, no la
       ventana, y el scroll de un elemento no burbujea pero si pasa por la captura. */
    document.addEventListener('scroll', this.alDesplazar, { passive: true, capture: true });

    this.vigilar();
    this.pintar();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.alClic);
    document.removeEventListener('change', this.alCambiar);
    document.removeEventListener(EVENTO, this.alEscalon);
    document.removeEventListener('scroll', this.alDesplazar, { capture: true });
    if (this.fotograma) cancelAnimationFrame(this.fotograma);
    this.observador?.disconnect();
  }

  /* === lo que vive fuera de la barra: se busca siempre, nunca se guarda === */

  botonReal() {
    return [...document.querySelectorAll('add-to-cart-component button[name="add"]')].find(
      (b) => !b.closest('sticky-add-to-cart') && !this.contains(b)
    );
  }

  campoCantidad() {
    return [...document.querySelectorAll('input[name="quantity"]')].find((c) => !this.contains(c));
  }

  tallaElegida() {
    return [...document.querySelectorAll('input[type="radio"][data-option-name]')].find(
      (r) => r.checked && r.dataset.optionName === this.opcion && !this.contains(r)
    );
  }

  /* LA OFERTA DEL ESCALON SIGUIENTE. Con 1 par ofrece 2; con 2 ofrece 3; y asi.
     Se lee del DOM que ya escribio Liquid en los escalones: la cantidad y el ahorro
     vienen FORMATEADOS EN PESOS en sus `data-*`, asi que aqui no se calcula ni se
     multiplica nada. Tampoco se cachea: el bloque de pares vive en `main`, que Horizon
     repinta al cambiar de talla.

     No hace falta filtrar escalones que no convengan: `_aud-escalon` ya no pinta el que
     no deje un ahorro positivo contra el precio vivo (la compuerta de D-033). En las dos
     fichas de $119.900 el escalon de 2 no existe, asi que aqui nunca se ofrece.

     Si el bloque de pares no esta en la ficha, no hay oferta y la franja se queda con su
     mensaje de reposo. */
  ofertaSiguiente() {
    const grupo = document.querySelector('aud-escalones');
    const plantilla = grupo?.dataset.anzueloPlantilla;
    if (!grupo || !plantilla) return '';

    const campo = this.campoCantidad();
    const actual = parseInt(campo?.value, 10) || 1;

    const siguiente = [...grupo.querySelectorAll('[data-aud-escalon]')]
      .filter((b) => b.dataset.ahorroTotal && (parseInt(b.dataset.cantidad, 10) || 0) > actual)
      .sort((a, b) => parseInt(a.dataset.cantidad, 10) - parseInt(b.dataset.cantidad, 10))[0];
    if (!siguiente) return '';

    return componer(plantilla, {
      n: siguiente.dataset.cantidad,
      ahorro: siguiente.dataset.ahorroTotal || '',
      ahorroPar: siguiente.dataset.ahorroPar || '',
      porPar: siguiente.dataset.porPar || '',
      total: siguiente.dataset.total || '',
    });
  }

  /* === aparecer y desaparecer === */

  /* CUÁNDO SE ENSEÑA (ajuste «Cuándo aparece», D-095, 2026-10-07).
       `fuera`  (por defecto): siempre que el botón real NO esté a la vista, esté arriba o
                abajo. Medido en la ficha publicada: el botón «Pedir» queda a 1.609 px en un
                celular de 375 × 667 —2,4 pantallas— y los cuatro primeros días del tema nuevo
                el tráfico de Instagram bajó de 4,6–5,2 % a 3,3 % en «agregar al carrito».
                Con la barra desde la primera pantalla, el botón nunca está a más de un toque.
       `pasado`: la regla anterior, solo cuando la caja de compra ya quedó ARRIBA (al cargar,
                el botón debajo del pliegue y la barra callada). */
  get soloPasado() {
    return this.dataset.desde === 'pasado';
  }

  vigilar() {
    this.observador?.disconnect();

    const boton = this.botonReal();
    if (!boton) {
      /* Sin botón real no hay nada que suplir, y el nuestro no tendría a quién delegar.
         Se queda con el `hidden` de Liquid: degradar con dignidad. */
      this.hidden = true;
      this.classList.remove('is-visible');
      return;
    }
    this.blanco = boton;

    /* `hidden` era solo el estado de partida. A partir de aquí manda la clase, que sí
       permite que la barra se deslice en vez de aparecer de golpe. */
    this.hidden = false;

    this.observador = new IntersectionObserver(
      ([entrada]) => {
        const r = entrada.boundingClientRect;
        this.ensenar(!entrada.isIntersecting && (!this.soloPasado || r.top < 0));
      },
      { threshold: 0 }
    );
    this.observador.observe(boton);
  }

  /* Enseña u oculta, y publica el alto real de la barra en `--aud-compra-alto`: con eso el
     CSS sube por encima de ella el botón flotante de la app de chat (CartHike), que va fijo
     con capa 1.000.000 y, sin esto, cae encima de «Agregar al carrito». El alto se mide
     porque cambia: sin franja la barra es mas baja. */
  ensenar(ver) {
    if (ver === this.classList.contains('is-visible')) return;
    this.classList.toggle('is-visible', ver);
    if (ver) document.documentElement.style.setProperty('--aud-compra-alto', this.offsetHeight + 'px');
  }

  /* RED DE SEGURIDAD DEL OBSERVADOR. Un salto brusco —un enlace a las reseñas, un «ir
     arriba»— puede llevar el boton de debajo de la pantalla a encima sin cruzarla, y el
     observador no avisa. Esto relee en cada fotograma de scroll. Solo alterna la clase:
     no mueve la barra, asi que no puede temblar. */
  alDesplazar = () => {
    if (this.fotograma) return;
    this.fotograma = requestAnimationFrame(() => {
      this.fotograma = 0;
      if (!this.blanco?.isConnected) return;
      const r = this.blanco.getBoundingClientRect();
      this.ensenar(this.soloPasado ? r.bottom < 0 : r.bottom < 0 || r.top > window.innerHeight);
      /* Dónde está la barra, para el chat de CartHike (ver el CSS de la sección):
         `is-abajo`  pegada al borde de la pantalla → el chat sube por encima de ella.
         `is-cerca`  ya subiendo con el pie pero aún en la franja donde vive el chat
                     (110 px: su sitio, 52 px, más su alto y aire) → el chat se desvanece.
         ninguna     la barra ya pasó → el chat vuelve a su sitio. */
      const abajo = this.getBoundingClientRect().bottom;
      const alto = window.innerHeight;
      this.classList.toggle('is-abajo', abajo >= alto - 2);
      this.classList.toggle('is-cerca', abajo < alto - 2 && abajo > alto - 110);
    });
  };

  /* Horizon repinta `main` al cambiar de talla y se lleva el boton observado por
     delante. Si el que vigilamos ya no esta en el documento, se vuelve a enganchar. */
  revisarVigilancia() {
    if (!this.blanco || !this.blanco.isConnected) this.vigilar();
  }

  /* === el paso de cantidad === */

  /* El tope sale de dos sitios y gana el menor: el `max` que Horizon pone en el campo
     cuando la tienda lleva inventario, y lo que sabemos de la talla elegida cuando le
     quedan 3 o menos. Nunca de un numero escrito aqui. */
  topeActual(campo) {
    const topes = [];

    const delCampo = parseInt(campo?.getAttribute('max'), 10);
    if (Number.isFinite(delCampo) && delCampo > 0) topes.push(delCampo);

    const radio = this.tallaElegida();
    const pocas = radio ? this.escasez[radio.dataset.variantId] : null;
    if (Number.isFinite(pocas) && pocas > 0) topes.push(pocas);

    if (topes.length === 0) return this.topeSuelto;
    return Math.min(...topes);
  }

  mover(direccion) {
    const campo = this.campoCantidad();
    if (!campo) return;

    const minimo = parseInt(campo.getAttribute('min'), 10) || 1;
    const salto = parseInt(campo.getAttribute('step'), 10) || 1;
    const actual = parseInt(campo.value, 10) || minimo;
    const tope = this.topeActual(campo);

    let valor = actual + direccion * salto;
    if (valor < minimo) valor = minimo;
    if (valor > tope) valor = tope;
    if (valor === actual) return;

    this.escribiendo = true;
    campo.value = String(valor);
    campo.dispatchEvent(new Event('input', { bubbles: true }));
    campo.dispatchEvent(new Event('change', { bubbles: true }));
    this.escribiendo = false;

    this.pintar();
  }

  /* === reaccionar === */

  alClic = (evento) => {
    if (evento.target.closest('[data-aud-menos]')) {
      evento.preventDefault();
      this.mover(-1);
      return;
    }
    if (evento.target.closest('[data-aud-mas]')) {
      evento.preventDefault();
      this.mover(1);
      return;
    }
    if (evento.target.closest('[data-aud-comprar]')) {
      evento.preventDefault();
      const real = this.botonReal();
      if (real) real.click();
    }
  };

  alCambiar = (evento) => {
    const campo = evento.target;
    if (!(campo instanceof HTMLInputElement)) return;
    if (this.contains(campo)) return;

    const esTalla = campo.type === 'radio' && (campo.dataset.optionName || '') === this.opcion;
    const esCantidad = campo.name === 'quantity';
    if (!esTalla && !esCantidad) return;

    /* El repintado de Horizon llega despues del evento: se espera un fotograma. */
    requestAnimationFrame(() => {
      this.revisarVigilancia();
      this.pintar();
    });
  };

  alEscalon = (evento) => {
    const datos = evento.detail || {};
    /* No se filtra por `ambito`: en una ficha hay una sola caja de compra, y la barra
       vive en OTRA seccion, asi que su `section.id` nunca coincidiria con el del
       bloque que manda el evento. */
    this.ahorroVigente = datos.lineaAhorro || '';
    this.anzuelo = Boolean(datos.esAnzuelo);
    if (datos.porPar && this.refPrecio) this.refPrecio.textContent = datos.porPar;
    this.pintarFranja();
    this.pintarPaso();
  };

  /* === pintar === */

  pintar() {
    this.pintarTalla();
    this.pintarFranja();
    this.pintarPaso();
  }

  pintarTalla() {
    const radio = this.tallaElegida();
    if (!radio) return;

    const talla = radio.value;
    const cm = this.medidas[talla];
    const texto = cm
      ? componer(this.plantillaTalla, { t: talla, cm: cm })
      : componer(this.plantillaSinCm, { t: talla });

    if (this.refTalla) this.refTalla.textContent = texto;

    /* Si el escalon no ha dicho nada, el precio es el de la variante elegida. */
    const suyo = this.precios[radio.dataset.variantId];
    if (this.refPrecio && suyo && !this.ahorroVigente) this.refPrecio.textContent = suyo;
  }

  /* UNA SOLA COSA A LA VEZ, y en este orden:
       1. escasez de la talla elegida — manda, porque es lo mas urgente y lo mas cierto
       2. la oferta del escalon SIGUIENTE — con 1 ofrece 2, con 2 ofrece 3, y asi
       3. el ahorro ya conseguido — solo en la cima de la escalera, donde ya no hay
          siguiente que ofrecer y callarse seria perder el unico argumento que queda
       4. el mensaje de reposo */
  pintarFranja() {
    if (!this.refFranja) return;

    const radio = this.tallaElegida();
    const pocas = radio ? this.escasez[radio.dataset.variantId] : null;

    if (Number.isFinite(pocas) && pocas > 0) {
      this.refFranja.textContent = componer(this.dataset.plantillaPocas, {
        n: pocas,
        t: radio.value,
      });
      this.refFranja.dataset.tono = 'escasez';
      this.refFranja.hidden = false;
      return;
    }

    const oferta = this.ofertaSiguiente();
    const texto = oferta || this.ahorroVigente || this.mensajeReposo;

    this.refFranja.textContent = texto;
    this.refFranja.dataset.tono = oferta || this.ahorroVigente ? 'ahorro' : 'reposo';
    this.refFranja.hidden = !texto;
  }

  pintarPaso() {
    const campo = this.campoCantidad();
    if (!campo) return;

    const valor = parseInt(campo.value, 10) || 1;
    const minimo = parseInt(campo.getAttribute('min'), 10) || 1;
    const tope = this.topeActual(campo);

    if (this.refValor) this.refValor.textContent = String(valor);
    if (this.refMenos) this.refMenos.disabled = valor <= minimo;
    if (this.refMas) this.refMas.disabled = valor >= tope;
  }
}

if (!customElements.get('aud-barra')) customElements.define('aud-barra', AudBarra);
